import { useSearchParams } from 'next/navigation';
import TextExpandablePanel from '@/features/text-expandable-panel';
import SafeHtml from '@/components/safe-html';
import useGetAppConfigurations from '@/app/_utils/use-get-app-configurations';
import { toNumberCommas } from '@/utils/string-helpers';
import { FAQ_DATA, FreeShippingPlaceHolder, PackagingCostPlaceHolder } from '../constants';
const FAQQuestions = () => {
  const searchParams = useSearchParams();
  const selectedCategory = searchParams.get('category');
  const {
    data
  } = useGetAppConfigurations();
  const selectedCategoryData = FAQ_DATA.find(({
    id
  }) => id === selectedCategory);
  const faqs = selectedCategoryData ? [selectedCategoryData] : FAQ_DATA;
  return faqs?.map((category, categoryIndex) => <div className='mb-6 flex flex-col text-text-black' key={categoryIndex}>
            <span className='mb-1.5 text-body-14 font-medium lg:mb-3 lg:text-body-16'>{category.category}</span>

            <div className='flex flex-col'>
                {category.faqs.map((faq, faqIndex) => {
        const uniqueKey = `category-${selectedCategory ? category.id : `all-${categoryIndex}`}-faq-${faqIndex}`;
        const freeShipmentCartMinPrice = data?.freeShipmentCartMinPrice;
        const packagingCost = (data?.packagingCost || 0) / 1000;
        const packagingCostText = packagingCost ? `به هزینه ارسال ذکر شده مبلغ بسته بندی معادل ${packagingCost} هزار تومان اضافه خواهد شد.` : '';
        const answer = faq.answer.replaceAll(PackagingCostPlaceHolder, packagingCostText).replaceAll(FreeShippingPlaceHolder, toNumberCommas(freeShipmentCartMinPrice || ''));
        return <TextExpandablePanel title={faq.question} key={uniqueKey} uniqueKey={uniqueKey}>
                            <SafeHtml as='p' content={answer} />
                        </TextExpandablePanel>;
      })}
            </div>
        </div>);
};
export default FAQQuestions;